import { Box, Button, Stack } from "@mui/material";
import { DataGrid, GridColDef, GridCellParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { RootState, useAppSelector } from "../../../store";
import PaginationControl from "../pagination/Pagination";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import {
  useDeleteDddFieldsMutation,
} from "../../../store/feature/service/dddFields";
import showAlert from "../../../utils/showAlert";
const DddFieldsTable = ({
  data,
  params,
  setParams,
  generateKeyField,
  successGenerateKey,
  isErrorGenerateKey,
}: any) => {
  // REGION: INIT VARIABLES
  const navigate = useNavigate();
  // const [pemName, setPemName] = useState("");
  const { dddFieldM } = useAppSelector((state: RootState) => state.role);
  const [deleteDddField, { isSuccess: successDelete, isError: errorDelete }] =
    useDeleteDddFieldsMutation();


  // REGION: RENDER BUTTON CELL
  const customCellRender = (params: GridCellParams) => {
    // REGION: NAVIGATE TO EDIT
    const onUpdate = (e: any) => {
      e.stopPropagation(); // don't select this row after clicking
      navigate(`/ddd-fields/edit/${params.row.uid}`);
    };

    const onCopyID = (e: any) => {
      e.stopPropagation(); // don't select this row after clicking
      navigate(`/ddd-fields/detail/${params.row.uid}`);
    };

    // REGION: DISPATCH DELETE DATA
    const onDelete = (e: any) => {
      e.stopPropagation(); // don't select this row after clicking
      Swal.fire({
        title: "Delete Confirmation",
        text: "Are you sure delete this DDD Field? You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#808080",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteDddField(params.row.uid);
        }
        console.log("kid ===> ", {
          kid: params.row.kid,
        });
      });
    };

    const onGenerateKey = (e: any) => {
      e.stopPropagation();
      Swal.fire({
        title: "Generate Confirmation",
        text: "Are you sure generate this Key DDD Field ?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#808080",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          generateKeyField(params.row.uid);
        }
      });
    };

    // REGION: RETURN TSX
    return (
      <>
        <Stack spacing={2} direction="row">
          {dddFieldM.update && (
            <Button variant="contained" onClick={onUpdate}>
              Update
            </Button>
          )}
          <Button variant="contained" onClick={onCopyID} color="success">
            Detail
          </Button>
          {dddFieldM.delete && (
            <Button variant="contained" color="error" onClick={onDelete}>
              Delete
            </Button>
          )}
          {dddFieldM.create && (
          <Button variant="contained" onClick={onGenerateKey} color="warning">
            Generate Key
            </Button>
          )}
        </Stack>
      </>
    );
  };

  // REGION: INIT COLUMNS
  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 250,
      headerClassName: "centered",
    },
    {
      field: "specificationVer",
      headerName: "Spesification Version",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "dauri",
      headerName: "Dauri",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "createdAt",
      headerName: "Date Created",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 400,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: customCellRender,
    },
  ];

  // REGION: INIT ROWS
  console.log("data form table ===> ", data);
  const dataRow =
    data?.data !== undefined && data?.data !== null ? data?.data : [];
  const rows = dataRow?.map((row: any, index: any) => ({
    // uid: row.uc_ocsp_config_uid,
    id: index,
    name: row.dsg_ddd_name,
    specificationVer: row.dsg_ddd_spec_version,
    createdAt: row.dsg_ddd_created_at,
    dauri: row.dsg_ddd_dauri,
    uid: row.dsg_ddd_uid,
    // appName: row.sworldAppname,
    // curved: row.curve
  }));

  useEffect(() => {
    if (successGenerateKey) {
      showAlert('success', 'Generate Key Success', 'Key successfully generated, go to keys management menu to download the CSR');
    }
    if (isErrorGenerateKey) {
      showAlert('error', 'Error Generate Key', 'Error Generate Key');
    }
  }, [successGenerateKey, isErrorGenerateKey]);

  useEffect(() => {
    if (successDelete) {
      showAlert('success', 'Success Delete', 'Success Delete');
    }
    if (errorDelete) {
      showAlert('error', 'Error Delete', 'Error Delete');
    }
  }, [successDelete, errorDelete]);


  // REGION: RETURN TSX
  return (
    <>
      <Box sx={{ height: "650px" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnMenu
          hideFooter
          disableColumnSelector
          disableDensitySelector
          disableSelectionOnClick
        />
      </Box>
      <PaginationControl
        params={params}
        setParams={setParams}
        total={data?.total_records}
      />
    </>
  );
};

export default DddFieldsTable;
